import { useEffect, useState } from "react";
import {Workshop} from "./models"
import { PaginationModels } from "src/components/pagination/models";
import useApi from "src/configs/api";
import Pagination from "src/components/pagination";

function classNames(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}

const Workshops = () => {
    const [loanApprovalData, setLoanApprovalData] = useState<Workshop.LoanApprovalData[] | null>([]);
    const [metadata, setMetadata] = useState<PaginationModels.MetaData | null>({
        page : 1,
        limit : 0,
        totalPages : 0,
        totalRecords : 0
    });
    const [currentPage, setCurrentPage] = useState<number>(1);
    const api = useApi();

    useEffect(() => {
    
        fetchLoanApprovalData(currentPage);
     }, [currentPage]);

      const fetchLoanApprovalData = async (currentPage : number) => {
        try {
            const res = await api.get("/workshop/loan_approvals?currentPage=" + currentPage);
            setLoanApprovalData(res.data.records);
            setMetadata(res.data.metadata);
        }
        catch (error) {console.error("Failed to fetch user details:", error);}
    }

     const onPageChange = (page : number) : void => {
        setCurrentPage(page);
        // fetchLoanApprovalData(page);
    }

    return (
        <>
        <div className="p-2 lg:px-3 overflow-hidden">
        <div className="lg:mx-0 lg:max-w-none overflow-hidden">
            <p className="text-base font-semibold leading-7 text-indigo-600">Workshop</p>
            <h1 className="mt-2 text-2xl font-bold tracking-tight text-gray-900">Comitting One Old Promise</h1>
            <div className="mt-5 grid max-w-xl text-sm md:text-base text-justify grid-cols-1 gap-5 leading-7 text-gray-700 lg:max-w-none ">
                <div>
                <p>
                    It's around the year of 2019, in my last year of college, when I first discovered machine learning. 
                    The perfect combo between computer programming and maths got me thinking, <i>"It must be a cool thing to do"</i>.
                    But I was really bad at coding at that time that I even thought about getting out of the IT world.
                    </p>
                <p className="mt-4 lg:mt-5 ">
                    This workshop reflects my couriousity about data processing. The dataset I'm going to use for training is from Kaggle, titled&nbsp; 
                    <a className="underline" href="https://www.kaggle.com/datasets/anishdevedward/loan-approval-dataset">Loan Approval Dataset</a>.
                    The dataset contains 2,000 row datas of customers including :
                    
                </p>
                <ol className="mt-3 max-w-xl space-y-1 text-gray-800 list-decimal list-inside">
                    <li>Customer name </li>
                    <li>City of origin </li>
                    <li>Credit score </li>
                    <li>Income </li>
                    <li>Loan amount </li>
                    <li>Years employed </li>
                    <li>Points </li>
                    <li>Approval Status </li>
                </ol>
                </div>
            </div>
            </div>
            <div className="overflow-x-auto overflow-y-auto max-h-[70vh] mt-10 ring-1 ring-gray-300 sm:rounded-lg">
                {
                    (loanApprovalData) && 
                        <table className="min-w-full divide-y divide-gray-300">
                            <thead className="bg-gray-100 sticky top-0">
                            <tr>
                                <th scope="col" className="py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">
                                
                                </th>
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900">
                                Name
                                </th>
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 ">
                                City
                                </th>
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-right text-sm font-semibold text-gray-900">
                                Income
                                </th>
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-right text-sm font-semibold text-gray-900">
                                Credit Score
                                </th>
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-right text-sm font-semibold text-gray-900">
                                Loan Amount
                                </th>
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-gray-900">
                                Years Employed
                                </th>
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-right text-sm font-semibold text-gray-900">
                                Points
                                </th>
                                <th scope="col" className="py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-gray-900">
                                Approval Status
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            metadata !== null && loanApprovalData.map((data, index) => (
                                <tr key={data.name}>
                                    <td
                                    className={classNames(
                                        index === 0 ? '' : 'border-t border-gray-200',
                                        ' px-3 py-3.5 text-sm text-gray-500 lg:table-cell'
                                    )}
                                    >
                                        {`${((metadata.page-1) * metadata.limit)+(index+1)}.`}
                                    </td>
                                    <td
                                    className={classNames(
                                        index === 0 ? '' : 'border-t border-gray-200',
                                        'px-3 py-3.5 text-sm text-gray-500 lg:table-cell'
                                    )}
                                    >
                                        {data.name}
                                    </td>

                                    <td
                                    className={classNames(
                                        index === 0 ? '' : 'border-t border-gray-200',
                                        'px-3 py-3.5 text-sm text-gray-500 lg:table-cell'
                                    )}
                                    >
                                        {data.city}
                                    </td><td
                                    className={classNames(
                                        index === 0 ? '' : 'border-t border-gray-200',
                                        'px-3 py-3.5 text-sm text-gray-500 lg:table-cell text-right'
                                    )}
                                    >
                                    {data.income}
                                    </td>
                                    <td
                                    className={classNames(
                                        index === 0 ? '' : 'border-t border-gray-200',
                                        'px-3 py-3.5 text-sm text-gray-500 lg:table-cell text-right'
                                    )}
                                    >
                                    {data.credit_score}
                                    </td>
                                    <td
                                    className={classNames(
                                        index === 0 ? '' : 'border-t border-gray-200',
                                        'px-3 py-3.5 text-sm text-gray-500 lg:table-cell text-right'
                                    )}
                                    >
                                    {data.loan_amount}
                                    </td>
                                    <td
                                    className={classNames(
                                        index === 0 ? '' : 'border-t border-gray-200',
                                        'px-3 py-3.5 text-sm text-gray-500 lg:table-cell text-center'
                                    )}
                                    >
                                    {data.years_employed ?? `0`}
                                    </td>
                                    <td
                                    className={classNames(
                                        index === 0 ? '' : 'border-t border-gray-200',
                                        'px-3 py-3.5 text-sm text-gray-500 lg:table-cell text-right' 
                                    )}
                                    >
                                    {data.points}
                                    </td>
                                    <td
                                    className={classNames(
                                        index === 0 ? '' : 'border-t border-gray-200',
                                        'px-3 py-3.5 text-sm  lg:table-cell text-center',
                                        data.is_loan_approved ? 'text-teal-500' : "text-red-500"
                                    )}
                                    >
                                    {
                                    (data.is_loan_approved ? 'Approved' : 'Rejected')
                                    }
                                    </td>
                                </tr>
                            ))
                        }
                        </tbody>
                        </table>
                }
                {
                    (loanApprovalData?.length == 0) && 
                    <div className="-mx-4 mt-10 ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg">
                        Unable to load data
                    </div>
                }
            </div>
            {(metadata &&
                <Pagination meta={metadata} onPageChange={onPageChange} />
            )}
        </div>        
        </>
    )
}

export default Workshops;